/**
 * Page section card.
 * Title comes first. Actions sit beside the title, before the body.
 * The surface is one light green so cards separate from the gray page.
 * Pass, fail, and warning colors stay on text and small marks, not on this surface.
 */
export const sectionTableHeadClass =
  'text-left text-xs font-semibold uppercase tracking-wide text-gray-500';

export default function SectionCard({
  title,
  actions,
  children,
  className = '',
  flush = false,
  ruled = true,
}) {
  const hasHeader = title != null || actions != null;
  return (
    <section
      className={`mb-4 overflow-hidden rounded-xl border border-green-300 bg-green-100 shadow-sm [&_input]:bg-green-100 [&_select]:bg-green-100 [&_textarea]:bg-green-100 ${className}`}
    >
      {hasHeader && (
        <div
          className={`flex flex-wrap items-center gap-x-3 gap-y-2 px-4 py-3 ${
            flush && ruled ? 'border-b border-green-300' : ''
          }`}
        >
          {title ? <h2 className="text-2xl font-bold tracking-tight text-gray-900">{title}</h2> : null}
          {actions}
        </div>
      )}
      {children != null && (
        <div className={flush ? '' : 'space-y-3 px-4 pb-4'}>{children}</div>
      )}
    </section>
  );
}
